import React from "react";
import { Link } from "react-router-dom";
import styles from "./about.module.scss";
import truckImage from "../../resources/images/truck.webp"

const About = () => {
  return (
    <div className={styles.whoWeAreContainer}>
      <h2 className={styles.title}>Who We Are</h2>
      <div className={styles.contentImageWrapper}>
        <div className={styles.contentWrapper}>
          <p className={styles.description}>
            Hot Freight International is a family-founded logistics company
            proudly serving North America since 1999. With over 100,000 sq. ft.
            of warehousing space across three facilities and advanced freight
            tracking technology, we deliver hands-on, dependable service you can
            trust.
          </p>
          <div className={styles.buttonLink}>
            <Link to="/WhoAreWe" className={styles.learnMoreButton}>
              LEARN MORE
            </Link>
          </div>
        </div>
        <div className={styles.imageSection}>
          <img
            src={truckImage}
            alt="Truck"
            loading="lazy"
            className={styles.truckImage}
          />
        </div>
      </div>
      <div className={styles.ratingSection}>
        <h3 className={styles.ratingText}>
          🌟 100% Superior Rating | SAI Global Food-Grade Certified Warehouse
          (2025)
        </h3>

        <p className={styles.ratingDescription}>
          From Mississauga to Abbotsford, our 100,000+ sq. ft. food-grade
          certified facilities keep your products moving reliably.
        </p>
        <p className={styles.ratingHighlight}>
          We are proud to be Food Grade Certified by Intertek SAI Global, one of
          the industry’s most trusted third-party auditors. Our warehouse earned
          a “100% Superior” rating in 2025 which is the highest possible score.
        </p>
      </div>
      <div className={styles.trustedBrands}>
        <p className={styles.trustedText}>
          Trusted by top food brands across North America:
        </p>
        <div className={styles.brandLogos}>
          <img
            src="costco-logo.png"
            alt="Costco"
            loading="lazy"
            className={styles.brandLogo}
          />
          <img
            src="metro-logo.png"
            alt="Metro"
            loading="lazy"
            className={styles.brandLogo}
          />
          <img
            src="loblaws-logo.png"
            alt="Loblaws"
            loading="lazy"
            className={styles.brandLogo}
          />
        </div>
      </div>
    </div>
  );
};

export default About;
